<template>
  <div>
    <div class="" :class="!isPc ? 'main-mobile' : 'main'" @click.stop="isPc ? $emit('hide') :''" v-loading="loading">
      <nav  class="nav_mobile_top topPadding" v-if="!isPc">
        <div class="nav_content">
          <div class="nav_left">
            <div class="back" @click="$emit('hide')"><img src="@/assets/img/icon_back.b2094a45.svg" alt="">
            </div>
            <div class="logo"><img src="@/assets/img/sax_logo.png" alt="">
            </div>
            <div class="nav_name">{{ $t('SmartTrading.createAPlan') }}</div>
          </div>
        </div>
      </nav>
      <div class="" id="content" :class="!isPc ? 'craeta-content' : 'content'" @click.stop="">
        <div class="title" v-if="isPc">{{ $t('SmartTrading.createAPlan') }}</div>
        <div class=""  :class="!isPc ? 'craeta-inputs-count' : 'inputs-count'">
          <div class="titles">{{ $t('SmartTrading.investmentRange') }}:</div>
          <div class="contents">{{ smartInfo[smartIndex] && smartInfo[smartIndex].min }}-{{ smartInfo[smartIndex] &&
            smartInfo[smartIndex].max }} <span>USD</span></div>
        </div>
        <div :class="!isPc ? 'craeta-inputs-count' : 'inputs-count'">
          <div class="titles">{{ $t('SmartTrading.dailyYield') }}:</div>
          <div class="contents">{{ smartInfo[smartIndex] && smartInfo[smartIndex].rate }}%</div>
        </div>
        <div :class="!isPc ? 'craeta-inputs-count' : 'inputs-count'">
          <div class="titles">{{ $t('SmartTrading.product') }}:</div>
          <div class="contents">{{ marketInfo.appName }}</div>
        </div>
        <div :class="!isPc ? 'craeta-inputs-count' : 'inputs-count'">
          <div class="titles">{{ $t('SmartTrading.timeframe') }}:</div>
          <div class="contents">
            <div class="content-down-button" :class="!isPc ? 'contents-button' : ''">
              <div class="clicek-points" @click="showTimeList = !showTimeList">
                {{ smartInfo[smartIndex] && smartInfo[smartIndex].days }} {{ $t('SmartTrading.days') }}
                <img src="@/assets/img/icon_down.5e285df7.svg" alt="" srcset="" />
              </div>
              <div class="select-lists" v-show="showTimeList">
                <div class="select-list clicek-points" @click="selectSmart(index)" v-for="(item, index) in smartInfo"
                  :key="index">{{ item.days }} {{ $t('SmartTrading.days') }}
                </div>
                <!-- <div class="select-list clicek-points">15 天</div>
                <div class="select-list clicek-points">30 天</div>
                <div class="select-list clicek-points">60 天</div>
                <div class="select-list clicek-points">90 天</div>
                <div class="select-list clicek-points">180 天</div>
                <div class="select-list clicek-points">360 天</div> -->
              </div>
            </div>
          </div>
        </div>
        <div :class="!isPc ? 'craeta-inputs-count' : 'inputs-count'">
          <div class="titles">{{ $t('SmartTrading.investment') }}:</div>
          <div class="contents">
            <input class="contents-button contents-button-input" v-model="smartMoney"
              :placeholder="$t('SmartTrading.InterInvestmentAmount')"
              onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
              onafterpaste="this.value=this.value.replace(/[^\d.]/g,'')" />
          </div>
        </div>
        <div class=" clicek-points" :class="!isPc ? 'button' : 'creat-btn'" @click="buySmart">{{ $t('SmartTrading.create') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { buySmart } from '@/api/market.js'
import { mapState } from "vuex";
export default {
  data() {
    return {
      showTimeList: false,//时间选择
      smartInfo: [],//交易详情
      smartIndex: 0,//交易详情索引
      smartMoney: '',//交易金额
      loading: false,
      id: '',
    }
  },
  computed: {
    ...mapState(["isPc"]),
  },
  name: 'Smart',
  props: {
    marketInfo: {
      type: Object,
      default: () => { }
    },
  },
  mounted() {
    console.log(this.marketInfo);
    this.smartInfo=this.marketInfo.smartInfo.smartInfo;

    // this.id=this.marketInfo.id;
    // this.smartInfo = this.marketInfo.smartInfo;
    // this.smartMoney = this.marketInfo.smartInfo[0].min;
  },
  methods: {
    buySmart() {
      console.log(this.smartMoney);
      if (!this.smartMoney) {
        this.$message({
          message: this.$t('SmartTrading.InterInvestmentAmount'),
          type: 'warning'
        });
        return;
      }
      this.loading=true;
      buySmart({
        marketId: this.marketInfo.smartInfo.id,
        allDay: this.smartInfo[this.smartIndex].days,
        amount: this.smartMoney,
        rate: this.smartInfo[this.smartIndex].rate,
      }).then(res => {
        console.log(res);
        if (res.code=='200') {
          this.$message({
            message: this.$t(res.message),
            type: 'success'
          })
          this.$emit('hide')
          // this.marketInfo={};
          // this.smartMoney='';
        } else {
          this.$message({
            message: this.$t(res.message),
            type: 'warning'
          })
        }

      }).finally(() => {
        this.loading=false;
      })

    },
    selectSmart(index) {
      this.smartIndex=index;
      this.showTimeList=false;
    },
  },

}
</script>
<style lang="scss" scoped>
.logo{
  border-radius: 50%;
}

.main {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .content {
  background: #fff;
  border-radius: 0.18rem;
  padding: 0.44rem;
}

.main .content .title {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: 0.34rem;
  line-height: 100%;
  color: #000;
  margin-bottom: 0.2rem;
}

.main .content .inputs-count {
  width: 5.73rem;
  height: 0.58rem;
  margin-bottom: 0.1rem;
  background: #fff;
  box-shadow: 0 0.14rem 0.24rem rgba(0, 0, 0, 0.04);
  border-radius: 0.16rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.24rem;
  position: relative;
}

.main .content .inputs-count .icon-bell {
  margin: 0 0.07rem;
  width: 0.3rem;
}

.main .content .inputs-count .contents,
.main .content .inputs-count .titles {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 0.18rem;
  line-height: 100%;
  text-align: right;
  color: #000;
}

.main .content .inputs-count .contents span {
  color: #3a3dff;
  font-size: 0.12rem;
}

.main .content .inputs-count .contents .contents-button {
  font-weight: 400;
  font-size: 0.14rem;
  color: rgba(0, 0, 0, 0.5);
  width: 2.27rem;
  height: 0.46rem;
  background: #f3f3f3;
  border-radius: 0.14rem;
  text-align: center;
  line-height: 0.46rem;
  position: relative;
  right: -0.18rem;
}

.main .content .inputs-count .contents .contents-button-input {
  color: #000;
}

.main .content .inputs-count .contents .content-down-button {
  width: 2.04rem;
  height: 0.46rem;
  background: #efefef;
  border-radius: 0.14rem;
  font-weight: 500;
  font-size: 0.16rem;
  color: #000;
  text-align: center;
  line-height: 0.46rem;
  position: relative;
  right: -0.18rem;
}

.main .content .inputs-count .contents .content-down-button .select-lists {
  position: absolute;
  width: 1.84rem;
  padding: 0.1rem 0.1rem;
  top: 0.5rem;
  background: #fff;
  z-index: 3;
  border-radius: 0.14rem;
}

.main .content .inputs-count .contents .content-down-button .select-lists .select-list {
  width: 100%;
  height: 0.48rem;
  line-height: 0.48rem;
}

.main .content .creat-btn {
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 500;
  font-size: 0.18rem;
  background: linear-gradient(180deg, #ffdc61, #ffbc49);
  border-radius: 0.24rem;
  text-align: center;
  line-height: 0.48rem;
  height: 0.48rem;
  margin-top: 0.3rem;
  width: 1.07rem;
}


.main-mobile {
  padding: 0 .24rem;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: #fff;
  z-index: 11;
  line-height: 100%
}

.main-mobile .craeta-content {
  width: calc(100% - .48rem);
  margin: auto;
  margin-top: 1rem;
}

.main-mobile .craeta-content .craeta-inputs-count {
  width: 100%;
  height: .58rem;
  background: #000;
  border-radius: .16rem;
  margin-bottom: .04rem;
  font-family: Mabry Pro;
  color: #fff;
  font-weight: 500;
  font-size: .14rem;
  line-height: .58rem;
  display: flex;
  justify-content: space-between;
  align-items: center
}

.main-mobile .craeta-content .craeta-inputs-count .titles {
  margin-left: .24rem;
  color: #fff
}

.main-mobile .craeta-content .craeta-inputs-count .contents {
  text-align: right;
  font-size: .18rem;
  margin-right: .24rem;
  color: #fff
}

.main-mobile .craeta-content .craeta-inputs-count .contents .icon-bell {
  margin: 0 .04rem;
  width: .3rem;
  vertical-align: middle
}

.main-mobile .craeta-content .craeta-inputs-count .contents span {
  color: #a5a6f5;
  font-size: .12rem
}

.main-mobile .craeta-content .craeta-inputs-count .contents .contents-button {
  background: #fff;
  border-radius: .14rem;
  width: 2.04rem;
  height: .48rem;
  position: relative;
  right: -.18rem;
  color: rgba(0, 0, 0, .5);
  text-align: center;
  line-height: .48rem;
  font-size: .14rem
}

.main-mobile .craeta-content .craeta-inputs-count .contents .content-down-button {
  color: #000;
  font-size: .16rem
}

.main-mobile .craeta-content .craeta-inputs-count .contents .content-down-button .select-lists {
  position: absolute;
  width: 1.84rem;
  padding: .1rem .1rem;
  top: .5rem;
  background: #fff;
  z-index: 3;
  border-radius: .14rem
}

.main-mobile .craeta-content .craeta-inputs-count .contents .content-down-button .select-lists .select-list {
  width: 100%;
  height: .48rem;
  line-height: .48rem
}

.main-mobile .craeta-content .craeta-inputs-count .contents .contents-button-input {
  color: #000
}

.main-mobile .button {
  position: fixed;
  bottom: .5rem;
  left: 50%;
  margin-left: -.84rem;
  background: #000;
  border-radius: .2rem;
  width: 1.68rem;
  height: .68rem;
  font-family: Mabry Pro;
  font-style: normal;
  font-weight: 700;
  font-size: .2rem;
  line-height: .68rem;
  text-align: center;
  color: #fff
}

.home-mobile .content[data-v-46f7e021] {
  margin-top: .9rem
}</style>